import Vue from 'vue'
import App from './App.vue'
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import '@/assets/styles/index.stylus' // global css
import ysbAddressFile from '@/assets/js/cityData.js';
import request from '@/util/request';
import router from './router/router';
import store from './store/index';
import util from '@/util/util';
import WebSocketClass from '@/util/webSocketSave';
import bindModel from '@/api/bindModel';
import printStatus from '@/api/printStatus';
import Vuex from 'vuex';
import _ from 'lodash';
import VueClipboard from "vue-clipboard2";
import VueCropper from 'vue-cropper'
Vue.config.productionTip = false
Vue.prototype.$post = request.post;
Vue.prototype.$get = request.get;
Vue.prototype.$WebSocketClass = WebSocketClass;
Vue.use(VueCropper)
Vue.use(ElementUI)
Vue.use(Vuex);
Vue.use(VueClipboard);
Vue.use(bindModel)
Vue.use(printStatus)
const on = Vue.prototype.$on //增加事件防抖和节流 
Vue.prototype.$on = function (event, func) {
  let newFunc = func
  if (event === 'click') {
    newFunc = _.debounce((...args) => { func.apply(this, args) }, 100)
  }
  on.call(this, event, newFunc)
}
/** 动态js引入 */
util.loadJs(window.location.origin + '/uploaded_files/js/cityData.js?time='+util.getlimiTime(0)).then(()=>{
  let ysbAddressFile = window.ysbAddressFile;
  Vue.prototype.ysbAddressFile = new ysbAddressFile()
}).catch(()=>{
  Vue.prototype.ysbAddressFile = ysbAddressFile
})
/** 路由监听 */
router.beforeEach((to, from, next) => {
    if(to.meta.title){
      document.title = to.meta.title
    }
    if(to.path){
       if(to.path == '/home'){
        store.state.nav_index = 0;
        store.state.activeMenu = '/home';
      }else if(to.path =='/customer'){
        store.state.nav_index = 1;
        store.state.activeMenu = '/customer';
      }else if(to.path =='/waitPrinted'){
        store.state.nav_index = 2;
        store.state.activeMenu = '/waitPrinted';
      }else if(to.path =='/printed'){
        store.state.nav_index = 3;
        store.state.activeMenu = '/printed';
      }else {
        store.state.activeMenu = to.path;
      }
      next();
    }
});
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
